var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "order-details--type my-5 mr-10" }, [
    _c(
      "div",
      {
        staticClass: "color-bo-danger bg-white pill ml-10 cursor-pointer",
        on: {
          click: function ($event) {
            return _vm.refund()
          },
        },
      },
      [
        _c("span", [_vm._v("Rembourser commande ")]),
        _vm._v(" "),
        _vm.simulate == 1
          ? _c("span", { staticClass: "text-small" }, [_vm._v("(sans HiPay)")])
          : _vm._e(),
        _vm._v(" "),
        _c("i", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.processing,
              expression: "processing",
            },
          ],
          staticClass: "loading",
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }